import { tables as developmentTables } from './tables/tables.development';
import { tables as stagingTables } from './tables/tables.staging';
import { tables as productionTables } from './tables/tables.production';

export const getPartnerEndpoints = function(partner = "compass", token = null) {
  const { REACT_APP_ENVIRONMENT, REACT_APP_BASE_URL, REACT_APP_MIS_BASE_URL } = process.env;
  let currentTables,
    estimateEndpoint,
    api = {};

  //Choosing correct tables
  switch (REACT_APP_ENVIRONMENT) {
    case 'staging':
      currentTables = stagingTables;
      break;
    case 'production':
      currentTables = productionTables;
      break;
    default:
      currentTables = developmentTables;
      break;
  }

  //Setting correct api.table value
  switch (REACT_APP_ENVIRONMENT) {
    case 'production': {
      api.table = `${currentTables[partner]['endpointOrigin']}/compass/prontuario/${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XX']},${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XZ']}${currentTables[partner]['parameters']['min'] ? "&min=" + currentTables[partner]['parameters']['min'] : ""}${currentTables[partner]['parameters']['max'] ? "&max=" + currentTables[partner]['parameters']['max'] : ""}&ass=`;
      api.tableOneMinute = `${currentTables[partner]['endpointOrigin']}/compass/prontuario/${window[currentTables[partner]['tassicfg_key']]['ONE_MINUTE']['9XX']},${window[currentTables[partner]['tassicfg_key']]['ONE_MINUTE']['9XZ']}${currentTables[partner]['one_minute']['parameters']['min'] ? "&min=" + currentTables[partner]['one_minute']['parameters']['min'] : ""}${currentTables[partner]['one_minute']['parameters']['max'] ? "&max=" + currentTables[partner]['one_minute']['parameters']['max'] : ""}&ass=`;
      break;
    }
    case 'staging':
    default: {
      //COLLAUDO
      //table: `${currentTables[partner]['endpointOrigin']}/simulatore/prontuarioProxy.aspx?tab=${currentTables[partner]['codes']['9XX']},${currentTables[partner]['codes']['9XZ']}${currentTables[partner]['parameters']['min'] ? "&min=" + currentTables[partner]['parameters']['min'] : ""}${currentTables[partner]['parameters']['max'] ? "&max=" + currentTables[partner]['parameters']['max'] : ""}&ass=`,
      api.table =  `${currentTables[partner]['endpointOrigin']}/simulatore/prontuarioProxy.aspx?tab=${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XX']},${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XZ']}${currentTables[partner]['parameters']['min'] ? "&min=" + currentTables[partner]['parameters']['min'] : ""}${currentTables[partner]['parameters']['max'] ? "&max=" + currentTables[partner]['parameters']['max'] : ""}&ass=`;
      api.tableOneMinute = `${currentTables[partner]['endpointOrigin']}/simulatore/prontuarioProxy.aspx?tab=${window[currentTables[partner]['tassicfg_key']]['ONE_MINUTE']['9XX']},${window[currentTables[partner]['tassicfg_key']]['ONE_MINUTE']['9XZ']}${currentTables[partner]['one_minute']['parameters']['min'] ? "&min=" + currentTables[partner]['one_minute']['parameters']['min'] : ""}${currentTables[partner]['one_minute']['parameters']['max'] ? "&max=" + currentTables[partner]['one_minute']['parameters']['max'] : ""}&ass=`;
      break;
    }
  }

  //Choosing correct partner
  switch (partner) {
    case 'mps':
      estimateEndpoint = 'mps';
      break;
    case 'chebanca':
    case 'chebancadem':
      estimateEndpoint = 'chb';
      break;
    default:
      estimateEndpoint = 'cmp';
      break;
  }

  api = {
    ...api,
    tableFallback: `/simulatore/prontuarioProxy.aspx?tab=${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XX']},${window[currentTables[partner]['tassicfg_key']]['STANDARD']['9XZ']}${currentTables[partner]['parameters']['min'] ? "&min=" + currentTables[partner]['parameters']['min'] : ""}${currentTables[partner]['parameters']['max'] ? "&max=" + currentTables[partner]['parameters']['max'] : ""}&ass=`,
    goodsList: `${currentTables[partner]['endpointOrigin']}/simulatore/ElencoBeni.aspx`,
    checkIfSimulatorIsDown: `https://api.appcenter.it/compass/testDS`,
    checkUserData: `${REACT_APP_BASE_URL}/webservices/Simulatore/NeedOTPConfirmation`,
    retrySendOTP: `${REACT_APP_BASE_URL}/webservices/Simulatore/NeedOTPConfirmation`,
    otpCheck: `${REACT_APP_BASE_URL}/webservices/Simulatore/CheckOTPConfirmation`,
    IsP1MEnabledByCseToken: `${REACT_APP_BASE_URL}/webservices48/api/Simulatore/IsP1MEnabledByCseToken`
  };

  const redirect = {
    estimateRedirect: `${REACT_APP_MIS_BASE_URL}/ds-webapp/recupero-pratica/${estimateEndpoint}`,
    formAction: `${REACT_APP_MIS_BASE_URL}/ds-webapp/start`,
    tokenRedirect: `${REACT_APP_BASE_URL}/vieni-in-filiale/token/info/${token}`, //capire se funzionante
  };

  return {
    api,
    redirect,
    currentTables
  };
}